const markLabel = [
    {
      id: 1,
      name: "已通过",
      color: "#00B573"
    },
    {
      id: 2,
      name: "流转中",
      color: "#FFB010"
    },
    {
      id: 3,
      name: "被退回",
      color: "#FF3D00"
    },
    {
      id: 4,
      name: "未提交",
      color: "#2567DB"
    },
    {
      id: 5,
      name: "未填写",
      color: "#989898"
    }
  ];

  export default markLabel



// WEBPACK FOOTER //
// ./src/components/todo/flowStatus.js